import React, { useState } from 'react';
import { Button, Divider, Stack, TextField, Typography } from '@mui/material';

/** Action block: carrier + tracking number → mark fulfilled. */
export default function FulfillAction({ busy, onSubmit }) {
  const [tracking, setTracking] = useState({ carrier: '', number: '' });
  return (
    <>
      <Divider sx={{ my: '14px' }} />
      <Typography variant='body2' fontWeight='700' mb='6px'>Fulfill</Typography>
      <Stack direction='row' spacing='8px' alignItems='flex-end' flexWrap='wrap'>
        <TextField
          size='small' label='Carrier'
          value={tracking.carrier}
          onChange={(e) => setTracking({ ...tracking, carrier: e.target.value })}
          placeholder='UPS' sx={{ flex: 1 }}
        />
        <TextField
          size='small' label='Tracking #'
          value={tracking.number}
          onChange={(e) => setTracking({ ...tracking, number: e.target.value })}
          placeholder='1Z…' sx={{ flex: 1 }}
        />
        <Button
          variant='contained'
          disabled={busy === 'Fulfill'}
          onClick={() => onSubmit(tracking)}
        >
          Mark fulfilled
        </Button>
      </Stack>
    </>
  );
}
